import {z} from 'zod';
import {DownloadRequestApprovalStatus} from '../downloadRequest/downloadRequestScheme';

export const DownloadRequestApprovalObjectSchema = z.object({
	all: z.boolean(),
	excludeIds: z.array(z.number().int().positive()),
	includeIds: z.array(z.number().int().positive()),
	total: z.number().int().positive(),
	id: z.number().int().positive(),
});

export const DownloadRequestApprovalAssetSchema = z.object({
	id: z.number().int().positive(),
	name: z.string(),
	fileType: z.string(),
	thumbUrl: z.string(),
});

export const DownloadRequestApprovalSchema = z.object({
	id: z.number().int().positive(),
	asset: DownloadRequestApprovalAssetSchema.nullable(),
	orderby: z.number().int(),
	approvalStatus: z.nativeEnum(DownloadRequestApprovalStatus),
});

/** all fields */
export const DownloadRequestApprovalField =
	DownloadRequestApprovalSchema.keyof().enum;

export type IDownloadRequestApprovalAsset = z.infer<
	typeof DownloadRequestApprovalAssetSchema
>;

export type IDownloadRequestApproval = z.infer<
	typeof DownloadRequestApprovalSchema
>;

export type IDownloadRequestApprovalObject = z.infer<
	typeof DownloadRequestApprovalObjectSchema
>;
